<template>
    <base-dashboard
        :sidebar-items="sidebarItems"
        :sidebar-footer-items="sidebarFooterItems"
        :loading="loading"
        :loading-text="loadingText"
    >
        <section
            class="wrapper-info d-flex justify-content-between align-items-center flex-wrap bg-white border-bottom px-1"
        >
            <page-title-selector />
            <simbar-breadcrumb />
        </section>
        <slot />
    </base-dashboard>
</template>

<script>
import BaseDashboard from "@/modules/dashboard/containers/BaseDashboard";
import SimbarBreadcrumb from "@/modules/dashboard/components/SimbarBreadcrumb";
import PageTitleSelector from "@/components/PageTitleSelector";

export default {
    name: "Dashboard",
    components: {
        PageTitleSelector,
        SimbarBreadcrumb,
        BaseDashboard
    },
    props: {
        sidebarItems: {
            required: true,
            type: Array
        },
        loading: {
            type: Boolean,
            default: false
        },
        loadingText: {
            type: String,
            default: ""
        },
        simulatorUrlName: {
            type: String,
            required: true
        }
    },
    computed: {
        sidebarFooterItems() {
            if (this.simulatorUrlName !== "") {
                return [
                    {
                        url: this.simulatorUrlName,
                        className: "simulator",
                        text: "Acessar simulador"
                    }
                ];
            }
            return [];
        }
    }
};
</script>

<style lang="scss" scoped>
.wrapper-info {
    min-height: 54px;
}
</style>
